import { useEffect, useMemo, useState } from "react";
// import useUpdateTaxRate from "./update-tax-rate.data";
import { UpdateTaxRateState } from "../../constants/category.constants";
import { Dropdown } from "react-bootstrap";
import TaxRateOptionItem from "./taxrate-option-item.component";
import AddEditTaxRateModal from "./AddEditTaxRateModal";
import useUpdateTaxRate from "./update-tax-rate.data";

const TaxRateDropdown = ({
  deleteTaxRate,
  updateTaxList,
  selected,
  onChange = () => { },
  taxList = [
    {
      ObjectId: 0,
      TaxCode: "Not Taxable",
      TaxName: "Not Taxable",
      TaxRate: 0,
      IsDefault: false,
    },
  ],
  imgClassName,
  error,
  disabled,
}) => {
  const [selectedTax, setSelectedTax] = useState({
    // ObjectId: 0,
    // TaxCode: "Not Taxable",
    // TaxName: "Not Taxable",
    // TaxRate: 0,
    // IsDefault: false,
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showEditTaxRate, setShowEditTaxRate] = useState(false);
  const [taxRateData, setTaxRateData] = useState({});
  const { isLoading, updateTaxRate } = useUpdateTaxRate();
  const [updatingArea, setUpdatingArea] = useState(UpdateTaxRateState.None);
  const filteredTaxList = useMemo(() => (
    taxList.filter((item) => !item.IsDisabled)
  ), [taxList]);

  useEffect(() => {
    if (selected) {
      setSelectedTax(selected);
    }
  }, [selected]);

  useEffect(() => {
    if (selected) return;
    let defaultTaxRate = filteredTaxList?.find((item) => item?.IsDefault);
    if (defaultTaxRate) {
      setSelectedTax(defaultTaxRate);
      onChange(defaultTaxRate);
    }
  }, [filteredTaxList, selected]);

  return (
    <Dropdown
      // alignRight
      className="transparennt-wrapper-dropdown tax-rate-parent-dropdown"
      onToggle={(e) => {
        setDropdownOpen(e);
      }}
    >
      <Dropdown.Toggle
        className="w-100 f-14 f-black"
        style={{
          backgroundColor: "f6f8fb",
          borderRadius: "4px",
          ...(error && { border: "1px solid #f36060" }),
        }}
        disabled={disabled}
      >
        <div className="d-flex align-items-center">
          <div
            className={`${selectedTax?.TaxName ? "f-black" : "f-grey"}  mr-2`}
          >
            {selectedTax?.TaxName ?? "Choose..."}
          </div>
          <img
            alt=""
            src="/images/big-chevron-down.svg"
            className={`${imgClassName ? imgClassName : 'mr-2 ml-auto '}  ${dropdownOpen ? "rotate180" : ""}`}
          />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="transparent-scroller px-1"
        style={{ width: "240px" }}
        id="tax-rate-dropdown"
        renderOnMount
      >
        <div className="hide-scrollbar" style={{ maxHeight: "250px", overflowY: "auto" }}>
          {filteredTaxList?.map((item, itemIndex) => {
            return (
              <TaxRateOptionItem
                isLoading={isLoading}
                updatingArea={updatingArea}
                updateTaxRate={updateTaxRate}
                setUpdatingArea={setUpdatingArea}
                updateTaxList={updateTaxList}
                setTaxRateData={setTaxRateData}
                setShowEditTaxRate={setShowEditTaxRate}
                item={item}
                onChange={onChange}
                selectedTax={selectedTax}
                key={itemIndex}
              />
            )
          })}
        </div>
        <hr className="my-2" />
        {showEditTaxRate ? (
          <AddEditTaxRateModal
            show={showEditTaxRate}
            hideModal={() => {
              setShowEditTaxRate(false);
            }}
            taxRateData={taxRateData}
            updateTaxList={updateTaxList}
            deleteTaxRate={deleteTaxRate}
          />
        ) : (
          <div
            className="f-blue  f-500 mb-2 pointer pl-2"
            onClick={(e) => {
              setShowEditTaxRate(true);
              setTaxRateData({
                ObjectId: 0,
                TaxCode: "",
                TaxName: "",
                TaxRate: "",
                IsDefault: false,
                IsDisabled: false,
              });
            }}
          >
            + Add a tax code
          </div>

        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TaxRateDropdown;

// export async function deleteTaxRate(_taxRateId) {
//   const authTokens = JSON.parse(localStorage.getItem("tokens"));
//   return new Promise((resolve, reject) => {
//     getAPIData(23, authTokens, {
//       optionEnum1: _taxRateId,
//     })
//       .then((response) => {
//         CallToast("Deleted Successfully", false, false, "v2style");
//         resolve(response);
//       })
//       .catch((err) => {
//         console.log(err);
//         reject(err);
//       });
//   });
// }


// export function updateTaxList(stoploading = false) {
//   getTaxRateList()
//     .then((response) => {
//       let selectedTaxIndex = taxList?.findIndex((item) => item?.ObjectId === selectedTax?.ObjectId);
//       if (selectedTaxIndex === -1) {
//         setSelectedTax(taxList?.find(f => f?.IsDefault) ?? {});
//       }
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// }

// export const useUpdateTaxRate = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const { createTaxRate } = useApiActions();

//   const updateTaxRate = async ({ ObjectId, TaxCode, TaxName, TaxRate, IsDefault, IsDisabled }) => {
//     setIsLoading(true);
//     try {
//       const response = await createTaxRate({ ObjectId, TaxCode, TaxName, TaxRate, IsDefault, IsDisabled });
//       return response;
//     } catch (error) {
//       console.error("Error updating tax rate", error);
//     } finally {
//       setIsLoading(false);
//     }
//   }

//   return { isLoading, updateTaxRate };
// }

